// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customSelect.MuiButtonBase-root.MuiMenuItem-root {
    padding-left: 0px;
    padding-right: 0px;
  }
  

 .customSelect .MuiSvgIcon-root {
    height: 16px !important;
    width: 16px !important;
  }

  .selectlistItem .MuiListItemText-root .MuiTypography-root {
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/CustomSelect/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;EACpB;;;CAGD;IACG,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB","sourcesContent":[".customSelect.MuiButtonBase-root.MuiMenuItem-root {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  \n\n .customSelect .MuiSvgIcon-root {\n    height: 16px !important;\n    width: 16px !important;\n  }\n\n  .selectlistItem .MuiListItemText-root .MuiTypography-root {\n    max-width: 250px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
